import React, { useState } from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"

import Seo from "../components/seo"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import { options } from "../utils/richtext"
import ModalVideo from "react-modal-video"
import AppearSensor from "../components/AppearSensor"

import "../components/styles/9-trumps/index.scss"

export const query = graphql`
  query ($slug: String!) {
    contentfulArticle(slug: { eq: $slug }) {
      id
      title
      slug
      seo
      node_locale
      body {
        raw
        references {
          ... on ContentfulAsset {
            # contentful_id is required to resolve the references
            contentful_id
            title
            description
            __typename
            file {
              url
              contentType
            }
            gatsbyImageData(width: 960)
          }
          ... on ContentfulMicrocopy {
            __typename
            contentful_id
            title
            key
            value {
              raw
            }
          }
          ... on ContentfulArticle {
            __typename
            contentful_id
            title
            slug
          }
        }
      }
    }
  }
`

const Article = props => {
  const [isOpen, setOpen] = useState(false)

  //console.log(props)
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  const customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/.*\//g, "")

  return (
    <React.Fragment>
      <ModalVideo
        channel="vimeo"
        autoplay="true"
        isOpen={isOpen}
        videoId="705331134"
        onClose={() => setOpen(false)}
      />

      <Layout location={props.location}>
        <Seo
          title={props.data.contentfulArticle.title}
          description={props.data.contentfulArticle.seo}
          pathname={"articles/" + props.data.contentfulArticle.slug}
          lang={props.data.contentfulArticle.node_locale}
        />
        <div className="content-wide hide">
          <div className="wide-container">
            <div className="wide-inner">
              <Breadcrumb
                crumbs={crumbs}
                crumbSeparator=" / "
                crumbLabel={customCrumbLabel}
              />
            </div>
          </div>
        </div>

        <div className="content_narrow">
          <h1>{props.data.contentfulArticle.title}</h1>
          <div className="article-body">
            {props.data.contentfulArticle.body &&
              renderRichText(props.data.contentfulArticle.body, options)}
          </div>
        </div>

        <div className="content-wide">
          <div className="wide-container">
            <div className="wide-inner">
              <div className="index-hero">
                <div className="grid">
                  <div className="g-2col-left">
                    <div className="hero-description align-center">
                      <div className="wrapper">
                        <AppearSensor key="hero-title">
                          {({ hasBeenVisible }) => {
                            return (
                              <h2
                                className={
                                  hasBeenVisible
                                    ? "fade-in-up was-in-view"
                                    : "fade-in-up"
                                }
                              >
                                What is a{" "}
                                <span className="emph-color">digital</span> care
                                guide?
                              </h2>
                            )
                          }}
                        </AppearSensor>
                        <AppearSensor key="hero-sub">
                          {({ hasBeenVisible }) => {
                            return (
                              <div
                                className={
                                  hasBeenVisible
                                    ? "fade-in-up--late fade-in-up was-in-view"
                                    : "fade-in-up--late fade-in-up"
                                }
                              >
                                <div>
                                  Watch this video to learn what a care guide is
                                  and how it helps both patients and healthcare
                                  system
                                  <br />
                                  <br />
                                  Contact us to learn more:
                                  <div className="index-hero-buttons">
                                    <a
                                      href="mailto:kontakt@emento.dk"
                                      className="button"
                                    >
                                      Email
                                    </a>
                                    <a
                                      href="tel:+4572227070"
                                      className="button"
                                    >
                                      Telefon
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )
                          }}
                        </AppearSensor>
                      </div>
                    </div>
                  </div>
                  <div className="g-2col-right">
                    <AppearSensor key="hero-video">
                      {({ hasBeenVisible }) => {
                        return (
                          <div
                            className={
                              hasBeenVisible
                                ? "hero-video fade-in--late fade-in was-in-view"
                                : "hero-video fade-in--late fade-in"
                            }
                          >
                            <div
                              onClick={() => setOpen(true)}
                              onKeyDown={() => setOpen(true)}
                              role="button"
                              tabIndex={0}
                              className="video-container"
                            >
                              <video
                                width="100%"
                                height="100%"
                                loop="loop"
                                autoPlay="autoplay"
                                playsInline="playsinline"
                                preload="none"
                                muted
                              >
                                <source
                                  src="//videos.ctfassets.net/f2lhpo6kur2q/34rjgSzAVdsFf79rqeKozR/7f3fd09ca7a620c0c486cc9b996b2317/emento_what_if_thumbnail_short.mp4"
                                  type="video/mp4"
                                ></source>
                              </video>
                            </div>
                          </div>
                        )
                      }}
                    </AppearSensor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  )
}

export default Article
